import CPCSIcon from "../pages/Dashboard/ServicesTab/ServicesIcons/cpcs.svg";
import FluIcon from "../pages/Dashboard/ServicesTab/ServicesIcons/flu.svg";
import HypertensionIcon from "../pages/Dashboard/ServicesTab/ServicesIcons/hypertension.svg";
import SmokingIcon from "../pages/Dashboard/ServicesTab/ServicesIcons/smoking.svg";
import NMSIcon from "../pages/Dashboard/ServicesTab/ServicesIcons/nms.svg";

const serviceIcons = {
  "(CPCS) Community pharmacist consultation service": <CPCSIcon />,
  "Flu vaccination service": <FluIcon />,
  "Hypertension case-finding": <HypertensionIcon />,
  "Smoking Cessation Service": <SmokingIcon />,
  "New Medicine Service": <NMSIcon />,
};
const kanbanIcon = (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.70986C0 1.03331 0.548451 0.484863 1.225 0.484863H9.975C10.6515 0.484863 11.2 1.03331 11.2 1.70986V3.45986C11.2 4.13641 10.6515 4.68486 9.975 4.68486H1.225C0.548451 4.68486 0 4.13641 0 3.45986V1.70986ZM1.225 1.53486C1.12835 1.53486 1.05 1.61321 1.05 1.70986V3.45986C1.05 3.55651 1.12835 3.63486 1.225 3.63486H9.975C10.0716 3.63486 10.15 3.55651 10.15 3.45986V1.70986C10.15 1.61321 10.0716 1.53486 9.975 1.53486H1.225Z"
      className="icons-color"
    />
    <path
      d="M0 6.60986C0 5.93331 0.548451 5.38486 1.225 5.38486H9.975C10.6515 5.38486 11.2 5.93331 11.2 6.60986V8.35986C11.2 9.03641 10.6515 9.58486 9.975 9.58486H1.225C0.548451 9.58486 0 9.03641 0 8.35986V6.60986ZM1.225 6.43486C1.12835 6.43486 1.05 6.51321 1.05 6.60986V8.35986C1.05 8.45651 1.12835 8.53486 1.225 8.53486H9.975C10.0716 8.53486 10.15 8.45651 10.15 8.35986V6.60986C10.15 6.51321 10.0716 6.43486 9.975 6.43486H1.225Z"
      className="icons-color"
    />
    <path
      d="M1.225 10.2849C0.548451 10.2849 0 10.8333 0 11.5099V13.2599C0 13.9364 0.548451 14.4849 1.225 14.4849H9.975C10.6515 14.4849 11.2 13.9364 11.2 13.2599V11.5099C11.2 10.8333 10.6515 10.2849 9.975 10.2849H1.225ZM1.05 11.5099C1.05 11.4132 1.12835 11.3349 1.225 11.3349H9.975C10.0716 11.3349 10.15 11.4132 10.15 11.5099V13.2599C10.15 13.3565 10.0716 13.4349 9.975 13.4349H1.225C1.12835 13.4349 1.05 13.3565 1.05 13.2599V11.5099Z"
      className="icons-color"
    />
  </svg>
);

const listviewIcon = (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.13025 10.246C3.79696 10.246 4.33743 10.7865 4.33743 11.4534V13.1767C4.33743 13.8435 3.79696 14.384 3.13025 14.384H1.40718C0.74047 14.384 0.199997 13.8435 0.199997 13.1767V11.4534C0.199997 10.7865 0.74047 10.246 1.40718 10.246H3.13025ZM3.13025 11.2809H1.40718C1.31193 11.2809 1.23472 11.3581 1.23472 11.4534V13.1767C1.23472 13.2719 1.31193 13.3492 1.40718 13.3492H3.13025C3.2255 13.3492 3.30271 13.2719 3.30271 13.1767V11.4534C3.30271 11.3581 3.2255 11.2809 3.13025 11.2809ZM5.54476 11.6244H13.481C13.7667 11.6244 13.9983 11.856 13.9983 12.1418C13.9983 12.4038 13.8037 12.6203 13.5512 12.6545L13.481 12.6592H5.54476C5.25903 12.6592 5.0274 12.4276 5.0274 12.1418C5.0274 11.8798 5.22204 11.6634 5.47456 11.6291L5.54476 11.6244H13.481H5.54476ZM3.13025 5.41584C3.79696 5.41584 4.33743 5.9564 4.33743 6.6232V8.34653C4.33743 9.01333 3.79696 9.55388 3.13025 9.55388H1.40718C0.74047 9.55388 0.199997 9.01333 0.199997 8.34653V6.6232C0.199997 5.9564 0.74047 5.41584 1.40718 5.41584H3.13025ZM3.13025 6.45072H1.40718C1.31193 6.45072 1.23472 6.52794 1.23472 6.6232V8.34653C1.23472 8.44178 1.31193 8.51901 1.40718 8.51901H3.13025C3.2255 8.51901 3.30271 8.44178 3.30271 8.34653V6.6232C3.30271 6.52794 3.2255 6.45072 3.13025 6.45072ZM5.54476 6.79495H13.481C13.7667 6.79495 13.9983 7.02661 13.9983 7.31238C13.9983 7.57434 13.8037 7.79083 13.5512 7.8251L13.481 7.82982H5.54476C5.25903 7.82982 5.0274 7.59816 5.0274 7.31238C5.0274 7.05043 5.22204 6.83393 5.47456 6.79967L5.54476 6.79495H13.481H5.54476ZM3.13025 0.585693C3.79696 0.585693 4.33743 1.12624 4.33743 1.79305V3.51637C4.33743 4.18318 3.79696 4.72373 3.13025 4.72373H1.40718C0.74047 4.72373 0.199997 4.18318 0.199997 3.51637V1.79305C0.199997 1.12624 0.74047 0.585693 1.40718 0.585693H3.13025ZM3.13025 1.62057H1.40718C1.31193 1.62057 1.23472 1.69779 1.23472 1.79305V3.51637C1.23472 3.61163 1.31193 3.68885 1.40718 3.68885H3.13025C3.2255 3.68885 3.30271 3.61163 3.30271 3.51637V1.79305C3.30271 1.69779 3.2255 1.62057 3.13025 1.62057ZM5.54476 1.96553H13.481C13.7667 1.96553 13.9983 2.19719 13.9983 2.48296C13.9983 2.74492 13.8037 2.96142 13.5512 2.99568L13.481 3.0004H5.54476C5.25903 3.0004 5.0274 2.76874 5.0274 2.48296C5.0274 2.22101 5.22204 2.00451 5.47456 1.97025L5.54476 1.96553H13.481H5.54476Z"
      className="icons-color"
    />
  </svg>
);

const calendarIcon = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99834 8.48486C5.55062 8.48486 5.99834 8.03715 5.99834 7.48486C5.99834 6.93258 5.55062 6.48486 4.99834 6.48486C4.44605 6.48486 3.99834 6.93258 3.99834 7.48486C3.99834 8.03715 4.44605 8.48486 4.99834 8.48486Z"
      className="icons-color"
    />
    <path
      d="M5.99834 10.4849C5.99834 11.0371 5.55062 11.4849 4.99834 11.4849C4.44605 11.4849 3.99834 11.0371 3.99834 10.4849C3.99834 9.93258 4.44605 9.48486 4.99834 9.48486C5.55062 9.48486 5.99834 9.93258 5.99834 10.4849Z"
      className="icons-color"
    />
    <path
      d="M7.99834 8.48486C8.55062 8.48486 8.99834 8.03715 8.99834 7.48486C8.99834 6.93258 8.55062 6.48486 7.99834 6.48486C7.44605 6.48486 6.99834 6.93258 6.99834 7.48486C6.99834 8.03715 7.44605 8.48486 7.99834 8.48486Z"
      className="icons-color"
    />
    <path
      d="M8.99834 10.4849C8.99834 11.0371 8.55062 11.4849 7.99834 11.4849C7.44605 11.4849 6.99834 11.0371 6.99834 10.4849C6.99834 9.93258 7.44605 9.48486 7.99834 9.48486C8.55062 9.48486 8.99834 9.93258 8.99834 10.4849Z"
      className="icons-color"
    />
    <path
      d="M10.9983 8.48486C11.5506 8.48486 11.9983 8.03715 11.9983 7.48486C11.9983 6.93258 11.5506 6.48486 10.9983 6.48486C10.4461 6.48486 9.99834 6.93258 9.99834 7.48486C9.99834 8.03715 10.4461 8.48486 10.9983 8.48486Z"
      className="icons-color"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9983 2.98486C14.9983 1.60415 13.879 0.484863 12.4983 0.484863H3.49834C2.11762 0.484863 0.998337 1.60415 0.998337 2.98486V11.9849C0.998337 13.3656 2.11762 14.4849 3.49834 14.4849H12.4983C13.879 14.4849 14.9983 13.3656 14.9983 11.9849V2.98486ZM1.99834 4.48486H13.9983V11.9849C13.9983 12.8133 13.3268 13.4849 12.4983 13.4849H3.49834C2.66991 13.4849 1.99834 12.8133 1.99834 11.9849V4.48486ZM3.49834 1.48486H12.4983C13.3268 1.48486 13.9983 2.15644 13.9983 2.98486V3.48486H1.99834V2.98486C1.99834 2.15644 2.66991 1.48486 3.49834 1.48486Z"
      className="icons-color"
    />
  </svg>
);

const analyticsIcon = (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7498 1.85923C13.1284 1.85923 12.6247 2.36297 12.6247 2.98436C12.6247 3.60575 13.1284 4.10948 13.7498 4.10948C14.3712 4.10948 14.8749 3.60575 14.8749 2.98436C14.8749 2.36297 14.3712 1.85923 13.7498 1.85923ZM11.4995 2.98436C11.4995 1.74157 12.507 0.7341 13.7498 0.7341C14.9926 0.7341 16.0001 1.74157 16.0001 2.98436C16.0001 4.22714 14.9926 5.23461 13.7498 5.23461C13.6285 5.23461 13.5093 5.22501 13.3932 5.20651L11.8644 7.7256C12.1076 8.085 12.2496 8.51843 12.2496 8.98504C12.2496 10.2278 11.2422 11.2353 9.99938 11.2353C9.32215 11.2353 8.7148 10.9361 8.30227 10.4627L5.49574 11.8658C5.49782 11.9054 5.49887 11.9453 5.49887 11.9854C5.49887 13.2282 4.49139 14.2356 3.24861 14.2356C2.00583 14.2356 0.998352 13.2282 0.998352 11.9854C0.998352 10.7426 2.00583 9.73513 3.24861 9.73513C4.04832 9.73513 4.7506 10.1523 5.1497 10.7809L7.79862 9.45664C7.76619 9.30456 7.74912 9.1468 7.74912 8.98504C7.74912 7.74226 8.7566 6.73478 9.99938 6.73478C10.3611 6.73478 10.7029 6.82015 11.0058 6.97183L12.3543 4.74974C11.8336 4.33759 11.4995 3.69999 11.4995 2.98436ZM9.99938 7.85991C9.37799 7.85991 8.87425 8.36365 8.87425 8.98504C8.87425 9.60643 9.37799 10.1102 9.99938 10.1102C10.6208 10.1102 11.1245 9.60643 11.1245 8.98504C11.1245 8.36365 10.6208 7.85991 9.99938 7.85991ZM3.24861 10.8603C2.62722 10.8603 2.12348 11.364 2.12348 11.9854C2.12348 12.6068 2.62722 13.1105 3.24861 13.1105C3.87 13.1105 4.37374 12.6068 4.37374 11.9854C4.37374 11.364 3.87 10.8603 3.24861 10.8603Z"
      className="icons-color"
    />
  </svg>
);

const documentIcon = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.84597 5.02021C8.52381 5.02021 8.26264 5.28138 8.26264 5.60354C8.26264 5.92571 8.52381 6.18688 8.84597 6.18688H11.5682C11.8904 6.18688 12.1515 5.92571 12.1515 5.60354C12.1515 5.28138 11.8904 5.02021 11.5682 5.02021H8.84597Z"
      className="icons-color"
    />
    <path
      d="M8.26269 9.88132C8.26269 9.55915 8.52385 9.29799 8.84602 9.29799H11.5681C11.8903 9.29799 12.1515 9.55915 12.1515 9.88132C12.1515 10.2035 11.8903 10.4647 11.5681 10.4647H8.84602C8.52385 10.4647 8.26269 10.2035 8.26269 9.88132Z"
      className="icons-color"
    />
    <path
      d="M6.92512 4.41329C7.15292 4.64109 7.15292 5.01044 6.92512 5.23824L5.36956 6.7938C5.14176 7.02161 4.77241 7.02161 4.5446 6.7938L3.76683 6.01602C3.53902 5.78822 3.53902 5.41887 3.76683 5.19106C3.99463 4.96326 4.36398 4.96326 4.59178 5.19106L4.95708 5.55636L6.10016 4.41329C6.32796 4.18548 6.69731 4.18548 6.92512 4.41329Z"
      className="icons-color"
    />
    <path
      d="M6.92512 9.51602C7.15292 9.28822 7.15292 8.91887 6.92512 8.69106C6.69731 8.46326 6.32796 8.46326 6.10016 8.69106L4.95708 9.83414L4.59178 9.46884C4.36398 9.24104 3.99463 9.24104 3.76683 9.46884C3.53902 9.69665 3.53902 10.066 3.76683 10.2938L4.5446 11.0716C4.77241 11.2994 5.14176 11.2994 5.36956 11.0716L6.92512 9.51602Z"
      className="icons-color"
    />
    <path
      d="M2.62375 0.742432C1.65725 0.742432 0.873749 1.52593 0.873749 2.49243V12.9924C0.873749 13.9589 1.65725 14.7424 2.62375 14.7424H13.1237C14.0902 14.7424 14.8737 13.9589 14.8737 12.9924V2.49243C14.8737 1.52593 14.0902 0.742432 13.1237 0.742432H2.62375ZM2.04042 2.49243C2.04042 2.17027 2.30158 1.9091 2.62375 1.9091H13.1237C13.4459 1.9091 13.7071 2.17027 13.7071 2.49243V12.9924C13.7071 13.3146 13.4459 13.5758 13.1237 13.5758H2.62375C2.30158 13.5758 2.04042 13.3146 2.04042 12.9924V2.49243Z"
      className="icons-color"
    />
  </svg>
);
export const commonData = {
  kanbanIcon,
  listviewIcon,
  analyticsIcon,
  documentIcon,
  calendarIcon,
  serviceIcons,
};

export default commonData;

